import * as React from 'react';
import {Image, ImageStyle, StyleSheet, View, ViewStyle} from 'react-native';

import NewBackgroundUsageHistoryButton from './NewBackgroundUsageHistoryButton';
import CreateBackgroundButton from './CreateBackgroundButton';

import convertImageSource from '../../../../../../helpers/convertImageSource';

import backgroundKeyVisualUri from '../../../../../../../assets/images/background_key_visual.png';

interface Props {
  enabledUploadBackground: boolean;
  onForwardToNewBackgroundUsageHistory: () => void;
  onPressCreateBackground?: () => void;
}

const NoBackgroundUsageHistories: React.FunctionComponent<Props> = props => {
  const {
    enabledUploadBackground,
    onForwardToNewBackgroundUsageHistory,
    onPressCreateBackground,
  } = props;
  return (
    <View style={styles.container}>
      <Image
        style={styles.image}
        resizeMode={'contain'}
        source={convertImageSource(backgroundKeyVisualUri)}
      />
      <View style={styles.button}>
        <NewBackgroundUsageHistoryButton
          style={{width: 240}}
          onPress={onForwardToNewBackgroundUsageHistory}
        />
      </View>
      {enabledUploadBackground && onPressCreateBackground && (
        <CreateBackgroundButton onPress={onPressCreateBackground} />
      )}
    </View>
  );
};

export default NoBackgroundUsageHistories;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  } as ViewStyle,
  image: {
    width: 130,
    height: 100,
    margin: 16,
  } as ImageStyle,
  button: {
    margin: 16,
  },
});
